import React, { Component, Fragment } from 'react'
import Picture from '../../components/Picture'
import DemoForm from '../../components/site/Forms/DemoForm'
import DemoFormB2B from '../../components/site/Forms/DemoFormB2B'

export default function Hero(props) {
    const demoForm = props.b2b ? <DemoFormB2B buttonOnly /> : props.stackedButtons ? (<DemoForm darkBg />) : (<DemoForm darkBg showOr modalLink />)


    let heroImg;
    switch (true) {
        case props.app:
            heroImg = (
                <Picture
                    className='hero-img-full-right hero-image-app'
                    src="/images/site/landing-pages/hero-app.png"
                    alt='Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B'
                    mobileSrc='/images/site/landing-pages/hero-app-mobile.png'
                />
            );
            break;
        case props.platform:
            heroImg = (
                <Picture
                    className='hero-img-full-right'
                    src="/images/site/landing-pages/hero-plataform.png"
                    alt='Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B'
                    mobileSrc='/images/site/landing-pages/hero-plataform-mobile.png'
                />
            );
            break;
        case props.b2b:
            heroImg = (
                <Picture
                    noWebp
                    className='hero-img-full-right'
                    src="/images/site/landing-pages/hero-b2b.png"
                    alt='Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B'
                    mobileSrc='/images/site/landing-pages/hero-b2b-mobile.png'
                />
            );
            break;
        case props.parceiros:
            heroImg = (
                <Picture
                    noWebp
                    className='hero-img-full-right'
                    src="/images/site/landing-pages/hero-b2b.png"
                    alt='Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B'
                    mobileSrc='/images/site/landing-pages/hero-b2b-mobile.png'
                />
            );
            break;
        default:
            heroImg = (
                <Picture
                    className='hero-img-full-right'
                    src="/images/site/landing-pages/hero-sistemas.png"
                    alt='Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B'
                    mobileSrc='/images/site/landing-pages/hero-sistemas-mobile.png'
                />
            );
            break;
    }

    return (
        <div className={`new-main-banner-v2 new-hero ${props.whiteBg ? 'new-hero-white-bg' : 'new-hero-purple-bg'} hero-v2${props.stackedButtons ? ' stacked-buttons' : ''}`}>
            <div className='container'>
                <div className="column">
                    <div className='title-wrapper'>
                        {props.overtitle ? <div className='label-small'>{props.overtitle}</div> : ""}
                        <h1 className='title'>{props.title}</h1>
                    </div>
                    <div className='main-subheading-container'>
                        <h2 className='description'>
                            {props.description}
                        </h2>
                    </div>
                    {demoForm}
                </div>
                <div className="column desktop-only">

                </div>
            </div>

            {heroImg}
            <div className="full-width-white-fill"></div>
        </div>
    )
}


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/LandingPageBlocks/Hero.jsx